<template>
  <div>
    <!-- Reporte 7 · Promociones, cupones y descuentos -->
    <exec-report-panel report-name="promotions" title="Promociones y descuentos" :filters="filters" @error="$emit('error', $event)" />
    <!-- Reporte 15 · Rentabilidad de promociones y beneficios -->
    <div class="mt-4">
      <exec-report-panel report-name="benefit-roi" title="Rentabilidad de beneficios" :filters="filters" @error="$emit('error', $event)" />
    </div>
  </div>
</template>

<script>
import ExecReportPanel from './ExecReportPanel.vue';
// Pestaña 6 · Promociones y beneficios (doc 04 §3, reportes 7 y 15).
export default { name: 'ExecPromotions', components: { ExecReportPanel }, props: { filters: { type: Object, default: () => ({}) } } };
</script>
